import { Link } from "react-router-dom";
import backIcon from "../assets/images/back.svg"
import sleepy from "../assets/images/Bunny-sleepy.gif"
import UpdateCardForm from "../components/UpdateCardForm";
import { HOME } from "../services/consts";

function Update() {
    return(
        <div className="block">
            <div className="container">
                <div className="status">
                    <Link to={HOME}>
                        <img className="back" src={backIcon} alt="back" />
                    </Link>
                    <h1 className="title">Changing..</h1>
                    <div className="empty"></div>
                    <img className="sleepy" src={sleepy} alt="bunny" />
                </div>
                <UpdateCardForm />
            </div>
        </div>
    );
}

export default Update;